import React from 'react'
import styles from './API.module.css'

export default function Row({ children }) {
  return (
    <div className={styles.row}>
      <div className={styles.rowInner}>{children}</div>
    </div>
  )
}
